import React from "react"
import { useEffect, useState } from "react"
import { NavItem, NavLink } from "reactstrap";
import Nav from 'react-bootstrap/Nav';
import InsurranceMenu from "./InsurranceMenu";
import Tab from 'react-bootstrap/Tab';
import InsurranceContent from "./InsurranceContent";

const InsurranceTopMenu = (props) => {
    const MenuItems = InsurranceMenu();
    const [tabs, setTabs] = useState([])
    const [component, setComponent] = useState({})
    const [subCategItems, setSubCategItems] = useState([]);
    const [activeTab, setActiveTab] = useState();
    const [reload, setReload] = useState(false);
    const [tabList, setTabsList] = useState([])
    useEffect(() => {
        const selected_Item_List = MenuItems.filter((item) => item.key === props.subCategKey);
        if (selected_Item_List && selected_Item_List.length > 0) {
            const subCategories = selected_Item_List[0].subCategoryItems;
            setSubCategItems(subCategories);
            const defaultTab = subCategories.find(item => item.right === true);
            setActiveTab(defaultTab?.key);
    
            if (defaultTab) {
                const defaultTabObject = {
                    key: defaultTab.key,
                    name: defaultTab.name,
                    right: defaultTab.right,
                    component: defaultTab.component,
                };
                setTabsList([defaultTabObject]); // <- Add default tab once here
            }
        }
    }, [props.subCategKey]);
    const handleActiveTab = (item) => {
        if (!item?.right) return;
    
        const newTabObject = {
            key: item.key,
            name: item.name,
            right: item.right,
            component: item.component,
        };
    
        const isTabExist = tabList.some(tab => tab.key === item.key);
        if (!isTabExist) {
            setTabsList(prev => [...prev, newTabObject]);
        }
    
        if (activeTab !== item.key) {
            setActiveTab(item.key);
        }
    };
    return (
        <>
            <div className="tabs-container h-100">
                <Tab.Container>
                    <div className="app-vertical-tabs h-100">
                        {/* <InsurranceList/> */}
                        <Tab.Content>
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="px-4 py-2">
                                        <div className="row align-items-center justify-content-between">
                                            <div className="col-md-3">
                                            </div>
                                            <div className="col-md-5">
                                                <div className='tabs-v2-custom w-fit-content'>
                                                    <Nav variant='tabs' className=''>
                                                        {subCategItems && subCategItems.map((item) => {
                                                            return (
                                                                <React.Fragment key={item.key}>
                                                                    <NavItem onClick={() => handleActiveTab(item)}>
                                                                        <NavLink href="#"
                                                                            // className={activeTab === item.key ? "active" : ""}
                                                                            className={`${activeTab === item.key ? "active" : ""} ${item.right === false ? 'sidebar-disableed' : ''}`} disabled={item.right}>
                                                                            {item.name}{item.icon}
                                                                        </NavLink>
                                                                    </NavItem>
                                                                </React.Fragment>
                                                            )
                                                        })}
                                                    </Nav>
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Tab.Content>
                    </div>
                </Tab.Container>
                <InsurranceContent activeTab={activeTab} dynamicTabs={tabList} subCategItems={subCategItems} Reload={props.Reload} ActivePatientID={props.ActivePatientID} />

            </div>
        </>
    )
}
export default InsurranceTopMenu